import { buildProps, definePropType } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import type Breadcrumb from './breadcrumb.vue'

export const styleType = ['default', 'card'] as const
export const sizeType = ['small', 'middle', 'large'] as const

// 完善的面包屑项类型定义
export interface BreadcrumbItem {
  key?: string

  title: string

  icon?: string

  url?: string

  target?: string

  type?: string

  onClick?: (event: MouseEvent, item: BreadcrumbItem, index: number) => void
}

export const breadcrumbProps = buildProps({
  items: {
    type: definePropType<BreadcrumbItem[]>(Array),
    default: () => [],
  },

  // 组件大小尺寸
  size: {
    type: String,
    values: sizeType,
    default: 'middle',
  },
  // 组件风格类型
  type: {
    type: String,
    values: styleType,
    default: 'default',
  },
  /**
   * 最大显示项数
   * @description 超过此数量的项将被折叠为省略号
   * @default 0 (不限制)
   */
  maxCount: {
    type: Number,
    default: 0,
  },
  // 显示隐藏项
  showHiddenItem: {
    type: Boolean,
    default: false,
  },

  // 是否启用链接跳转
  isLinkSkip: {
    type: Boolean,
    default: false,
  },

  /**
   * 是否显示文字前图标
   */
  showIcon: {
    type: Boolean,
    default: true,
  },

  // 图标颜色
  iconColor: {
    type: String,
    default: 'var(--default-icon)',
  },

  // 末级图标颜色
  lastIconColor: {
    type: String,
    default: 'var(--header-icon-color)',
  },

  // 分隔符
  separator: {
    type: String,
    default: '/',
  },
  // 分隔符间距
  separatorSpace: {
    type: Number,
    default: 8,
  },
  // 分隔符颜色
  separatorColor: {
    type: String,
    default: 'var(--color-border-secondary)',
  },

  // 文本颜色
  titleColor: {
    type: String,
    default: '#86909C',
  },

  // 末级文本颜色
  lastTitleColor: {
    type: String,
    default: 'var(--color-text)',
  },

  // 悬浮文本颜色
  hoverTitleColor: {
    type: String,
    default: 'var(--color-text)',
  },
})

export type BreadcrumbProps = ExtractPropTypes<typeof breadcrumbProps>

// instance
export type BreadcrumbInstance = InstanceType<typeof Breadcrumb>
